module.exports = __webpack_public_path__ + "static/media/tv.00f5e81f.svg";